import { hasCapability, type User } from "../base";

export const creditMemo = {
  create: (user: User) => hasCapability(user, "creditMemo.create"),
  read: (user: User) => hasCapability(user, "creditMemo.read"),
  delete: (user: User) => hasCapability(user, "creditMemo.delete"),
};
